export default __webpack_public_path__ + "static/media/EsilioPic4.4d32b36c.png";